import { LockOutlined } from "@mui/icons-material";
import {
  AppBar,
  DialogContent,
  DialogTitle,
  Drawer, Grid, IconButton, List,
  ListItem,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  styled,
  SvgIcon,
} from "@mui/material";
import ListItemComponent from "../commons/menuAppBar/MenuItem";

export const StyledDrawer = {
  Drawer: styled(Drawer)(({ theme, open }) => ({
    width: '260px',
    borderRight: 0,
    flexShrink: 0,
    whiteSpace: "nowrap",
    backgroundColor: "white",
    marginTop: '65px',
    overflow: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      overflowY: "auto",
    }),
    ...(!open && {
      width: theme.spacing(8),
      paddingRight: '-15px',
      '&:hover': {
        overflowY: 'overlay',
        '&::-webkit-scrollbar': {
          width: '0.4em !important',
        },
      },
    }),
    '& .MuiDrawer-paper': {
      width: '260px',
      top: "65px",
      bottom: 0,
      height: 'auto',
      overflowY: "auto",
      ...(!open && {
        width: theme.spacing(8),
        overflowY: "hidden",
        '&:hover': {
          overflowY: 'overlay',
        },
      }),

    }
  })),
  Toolbar: styled('div')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    position: "fixed",
    top: '0px',
    left: '15px',
    zIndex: 9999,
    justifyContent: "flex-end",
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
    backgroundColor: "white",
  })),
  ArrowToolbar: styled(IconButton)(({ theme }) => ({
    marginLeft: 15,
    color: theme.palette.primary.menuItem,
  })),
  Logo: styled('img')(({ theme }) => ({
    height: 50,
  })),
};


export const StyledMenuAppBar = {
  ItemComponent: styled(ListItemComponent)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
  })),
  NavBar: styled(List)(({ theme }) => ({
    [theme.breakpoints.down(600)]: {
      width: 10,
    },
  })),
  ExpandArrow: styled('div')(({ theme }) => ({
    color: theme.palette.primary.menuItem,
    display: "flex",
    alignItems: "center",
  })),
  NodeParentText: styled('p')(({ theme }) => ({
    color: theme.palette.primary.menuItem,
    fontFamily: "Roboto, sans-serif",
    margin: 0,
    marginLeft: "8px",
    fontWeight: "bold",
    flex: 1,
  })),
  NodeParent: styled(ListItem)(({ theme }) => ({
    marginTop: "8px",
    borderRadius: "7px",
    width: "auto",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    "& .MuiSvgIcon-root": {
      marginLeft: 8,
    },
  })),
  Icon: styled('div')(({ theme }) => ({
    color: theme.palette.primary.menuItem,
  })),
}

export const StyledMenuItem = {
  Nested: styled(ListItem)(({ theme, itemSelected }) => ({
    width: "auto",
    marginTop: "8px",
    borderRadius: "7px",
    backgroundColor: itemSelected ? "rgba(0, 0, 0, 0.08)" : "transparent",
    "&:hover": {
      backgroundColor: itemSelected ? "rgba(0, 0, 0, 0.12)" : "rgba(0, 0, 0, 0.04)",
    },
  })),
  Text: styled('p')(({ theme, itemSelected }) => ({
    color: theme.palette.primary.menuItem,
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bold",
    margin: 0,
  })),
  Icon: styled(ListItemIcon)(({ theme, itemSelected }) => ({
    color: theme.palette.primary.menuItem,
    marginLeft: 8,
  })),
}

export const StyledMenuSubItem = {
  Nested: styled(ListItem)(({ theme, itemSelected }) => ({
    borderRadius: "7px",
    backgroundColor: itemSelected ? "rgba(0, 0, 0, 0.08)" : "transparent",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(2),
    },
    "&:hover": {
      backgroundColor: itemSelected ? "rgba(0, 0, 0, 0.12)" : "rgba(0, 0, 0, 0.04)",
    },
  })),
  List: styled(List)(({ theme, open }) => ({
    color: "white",
    borderRadius: "7px",
    marginTop: 5,
    marginLeft: open ? 15 : 0,
    marginRight: open ? 8 : 0,
  })),
  ListIcon: styled(ListItemIcon)(({ theme, itemSelected }) => ({
    color: "black",
    marginLeft: 8,
    [theme.breakpoints.down(600)]: {
      marginLeft: 0,
    },
  })),
  RightIcon: styled(ListItemIcon)(({ theme, itemSelected }) => ({
    color: theme.palette.primary.main,
    marginLeft: 30,
  })),
  Text: styled('p')(({ theme }) => ({
    color: theme.palette.primary.menuItem,
    fontFamily: "Roboto, sans-serif",
    fontSize: 14,
    margin: 0,
    marginLeft: -10,
  })),
};

export const StyledHeader = {
  AppBar: styled(AppBar)(({ theme, open }) => ({
    boxShadow: "0 0 0 0",
    backgroundColor: "white",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: 250,
      width: `calc(100% - ${250}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    })
  })),
  MenuButton: styled(IconButton)(({ theme, open }) => ({
    marginRight: 36,
    color: theme.palette.primary.menuItem,
    ...(open && {
      display: "none",
    })
  })),
  Logout: styled('div')(({ theme }) => ({
    position: "absolute",
    top: 20,
    right: 20,
    cursor: "pointer",
    color: theme.palette.primary.menuItem,
  })),
  Consulta: styled('div')(({ theme }) => ({
    position: "absolute",
    top: 20,
    right: 60,
    cursor: "pointer",
    color: theme.palette.primary.menuItem,
  })),
  Menu: styled(Menu)(({ theme }) => ({
    marginTop: 20,
    marginLeft: 0,
  })),
  ListItemIcon: styled(ListItemIcon)(({ theme }) => ({
    marginRight: -3,
  })),
}

export const StyledHeaderLabel = {
  PaperOutlined: styled(Paper)(({ theme }) => ({
    flex: 1,
    borderRadius: 5,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
  })),
  HeaderDiv: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    padding: 8,
  })),
}

export const StyledRouting = {
  Content: styled('main')(({ theme, isAuthenticated }) => ({
    flexGrow: 1,
    padding: isAuthenticated && theme.spacing(2),
    width: theme.spacing(1),
    overflow: "auto",
  })),
  Root: styled('div')(({ theme, isAuthenticated }) => ({
    display: "flex",
    flex: 1,
    marginTop: isAuthenticated ? "58px" : 0,
    backgroundColor: "#f5f6fa",
  }))
}

export const StyledContainer = {
  Paper: styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
  })),
}

export const StyledUserActions = {
  IconButton: styled(IconButton)(({ theme }) => ({
    padding: 0,
  })),
  MenuItem: styled(MenuItem)(({ theme }) => ({
    padding: "10px",
  })),
  MenuItemIcon: styled(SvgIcon)(({ theme }) => ({
    paddingRight: "10px",
    color: theme.palette.primary.menuItem,
  })),
  MenuList: styled(MenuList)(({ theme }) => ({
    paddingTop: "8px",
  })),
  TextEmpleadorActual: styled('span')(({ theme }) => ({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
    maxWidth: "200px",
    color: theme.palette.primary.menuItem,
  })),
  InfoMenuItem: styled(MenuItem)(({ theme }) => ({
    color: theme.palette.primary.menuItem,
    whiteSpace: "nowrap",
    cursor: 'default',
    padding: "10px",
  })),
  Menu: styled(Menu)(({ theme }) => ({
  }))
}

export const StyledChangePassword = {
  RowContainer: styled(Grid)(({ theme }) => ({
    display: "flex",
    padding: "10px",
    alignItems: "center",
  })),
  LockIcon: styled(LockOutlined)(({ theme }) => ({
    flex: "0 0 10%",
    marginTop: "10px",
  })),
  FormField: styled('span')(({ theme }) => ({
    flex: "0 0 80%",
  })),
  TitleContainer: styled(DialogTitle)(({ theme }) => ({
    backgroundColor: `${theme.palette.primary.main}`,
    borderBottom: "1px solid green",
    boxSizing: "border-box",
    textAlign: "center",
    color: "white",
    padding: "5px 120px 5px 120px",
  })),
  DialogContent: styled(DialogContent)(({ theme }) => ({
    textAlign: "center",
    padding: 25,
  })),
}